// @flow
import React, { Component } from 'react';
import Chartist from 'chartist';
import ChartistGraph from 'react-chartist';

import { PrimaryButton } from '../../../Buttons.jsx';

import ageHC from './constants/hcageinf';

type Props = {
  measurements: Object[],
  sex: string,
}

type State = {
  unit: string,
}

class InfantHCAgeChart extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      unit: 'cm',
    };
  }

  toggleUnits = () => {
    this.setState({
      unit: (this.state.unit === 'in' ? 'cm' : 'in'),
    });
  }

  // needed to re-render based on unit properly for Chartist plugin
  getYAxis = () => `Head Circumference (${this.state.unit})`;

  render() {
    const CM_TO_IN = 2.54;
    const { unit } = this.state;
    const measurements = this.props.measurements.slice()
      // eslint-disable-next-line no-restricted-globals
      .filter(x => !isNaN(x.age))
      .sort((a, b) => a.age - b.age)
      .map((item) => {
        const x = item.age;
        const y = (unit === 'cm' ? item.headCircumference
          : item.headCircumference && (item.headCircumference / CM_TO_IN).toFixed(1));
        const percentile = item.hcPercentile;
        return {
          value: { x, y },
          // string for popover text
          meta: `Age: ${x} m, Length: ${y} ${unit} (${percentile}%)`,
        };
      });

    const {
      p3, p10, p25, p50, p75, p90, p97,
    } = ageHC[this.props.sex];
    const percentiles = [p3, p10, p25, p50, p75, p90, p97];
    const labels = ['3', '10', '25', '50', '75', '90', '97'];
    for (let i = 0; i < percentiles.length; i++) {
      percentiles[i] = percentiles[i].map((val, index) => ({
        x: (index === 0 ? 0 : index === 37 ? 36 : index - 0.5),
        y: (unit === 'cm' ? val : val / CM_TO_IN),
        label: labels[i],
      }));
    }
    // plot single points at end of line to have labels for percentile lines
    const percentileLabels = percentiles.map(p => ({
      name: 'percentileLabels',
      data: [p[p.length - 1]],
    }));

    const data = {
      series: [...percentiles, ...percentileLabels,
        {
          name: 'measurements',
          data: measurements,
        },
      ],
    };

    const options = {
      series: {
        measurements: {
          showPoint: true,
          lineSmooth: Chartist.Interpolation.none({
            fillHoles: true,
          }),
        },
        percentileLabels: {
          showPoint: true,
        },
      },
      axisX: {
        labelOffset: {
          x: -7,
          y: 0,
        },
        type: Chartist.FixedScaleAxis,
        high: 37,
        low: 0,
        divisor: 37,
        labelInterpolationFnc: value => (value === 0 ? 'Birth' : value % 3 === 0 ? value : ''),
      },
      axisY: {
        labelOffset: {
          x: 0,
          y: 7,
        },
        type: Chartist.FixedScaleAxis,
        high: (unit === 'cm' ? 55 : 22),
        low: (unit === 'cm' ? 28 : 11),
        divisor: (unit === 'cm' ? 27 : 11),
        // don't interpolate if unit is inches (display each line), else every 2
        labelInterpolationFnc: value => (value % 2 === 0 || unit === 'in' ? value : ''),
      },
      showPoint: false,
      height: '85vh',
      chartPadding: {
        bottom: 10,
        left: 10,
      },
      plugins: [
        Chartist.plugins.ctAxisTitle({
          axisX: {
            axisTitle: 'Age (months)',
            offset: {
              x: 0,
              y: 35,
            },
          },
          axisY: {
            axisTitle: this.getYAxis,
            offset: {
              x: 0,
              y: 10,
            },
            flipTitle: true,
          },
        }),
        Chartist.plugins.tooltip(),
        Chartist.plugins.ctPointLabels({
          textAnchor: 'start',
          labelOffset: {
            x: 3,
            y: 4,
          },
        }),
      ],
    };

    return (
      <div>
        <PrimaryButton onClick={this.toggleUnits}>Toggle Units</PrimaryButton>
        <ChartistGraph data={data} options={options} type={'Line'} />
      </div>
    );
  }
}

export default InfantHCAgeChart;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/growthChart/infant/InfantHCAgeChart.jsx